window.addEventListener('DOMContentLoaded', initPageTiles);
const handleResizeThrottled = throttle(initPageTiles, 300);
window.addEventListener('resize', handleResizeThrottled);
function initPageTiles() {
  document.querySelectorAll('.tile-description-link .c-label').forEach(label => {
    const height = label.querySelector('.c-description')?.offsetHeight;
    if (!height) return;
    label.style.setProperty('--description-height', `${height}px`);
  });
}
function throttle(fn, time) {
  let timeout = null;
  return function () {
    if (timeout) return;
    const context = this;
    const args = arguments;
    const later = () => {
      fn.call(context, ...args);
      timeout = null;
    };
    timeout = setTimeout(later, time);
  };
}